import { defineEnvVariable } from '@nzyme/ioc/defineEnvVariable.js';
import { DOMAIN_TOP_LEVEL } from '@sigma/env/resources.js';
export const COGNITO_USER_POOL_DOMAIN = defineEnvVariable('COGNITO_USER_POOL_DOMAIN');
export const COGNITO_USER_POOL_CLIENT_ID = defineEnvVariable('COGNITO_USER_POOL_CLIENT_ID');
export const COGNITO_USER_POOL_ID = defineEnvVariable('COGNITO_USER_POOL_ID');
export const VAPID_PUBLIC_KEY = defineEnvVariable('VAPID_PUBLIC_KEY');
export const VAPID_CONTACT_EMAIL = `contact@${DOMAIN_TOP_LEVEL}`;
//# sourceMappingURL=env.js.map